<template>
  <div class="container py-20">
    <div class="bg-white max-w-xl m-auto py-10 px-5" v-show="!error">
      <h1 class="text-2xl text-center">Please wait a moment...</h1>
      <h3 class="text-xl text-center my-4">You will be forwarded.</h3>
      <div>
        <img src="/assets/images/site/uploader-loader.gif" class="m-auto" />
      </div>
    </div>

    <div class="bg-white max-w-xl m-auto py-10 px-5" v-show="error">
      <h1 class="text-2xl text-center">Uh, oh!</h1>
      <h3 class="text-xl text-center my-4">
        There was an error while fetching invitation details.
        Your invitation might be expired.
      </h3>
      <p class="text-center">
        <a href="/account/details">Click here to continue...</a>
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  methods: {
    ...mapActions({
      setInviteTokenAndRedirect: "teamInvitation/setInviteTokenAndRedirect",
    }),
  },
  computed: {
    ...mapState({
      error: (state) => state.teamInvitation.error,
    })
  },
  mounted() {
    this.setInviteTokenAndRedirect({
      token: this.$route.params.token,
      router: this.$router
    })
  },
  metaInfo: () => ({
    bodyAttrs: { class: "login-page" },
    title: "Invitation | Motion Array",
    link: [{ rel: "stylesheet", href: "/assets/site/css/team-invite.css" }],
  }),
};
</script>

<style scoped></style>
